import { IcoClose } from "assets/icons";
import { useState } from "react";
import { AlertBannerProps } from "./types";

export default function AlertBanner(props: AlertBannerProps) {
	const { message, linkText, linkHref, onClose } = props;
	const [visible, setVisible] = useState(true);

	if (!visible) return null;

	return (
		<div className="w-full bg-branding-high-50 text-center py-3 relative flex items-center justify-center">
			<p className="text-sm text-neutral-low-750 flex">
				{message}{" "}
				{linkText && linkHref && (
					<a
						href={linkHref}
						target="_blank"
						rel="noopener noreferrer"
						className="text-branding-pure-500 underline font-medium ml-1"
					>
						{linkText}
					</a>
				)}
			</p>

			<button
				onClick={() => {
					if (onClose) {
						onClose();
					}
					setVisible(false);
				}}
				className="absolute right-4 text-neutral-500 hover:text-neutral-800"
				aria-label="Fechar aviso"
			>
				<IcoClose size="24" />
			</button>
		</div>
	);
}
